import styled from 'styled-components';

import { ScButtonWrapper } from '@/components/buttons/Button/styled';
import { device } from '@/styles/helpers';

export const ScLogin = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;

  @media (${device.mobile}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 8px 0;

    & > button {
      position: fixed;
    }
  }
`;

export const ScLoginContent = styled.div`
  position: relative;
  padding: 32px 32px 0;
  border-radius: 24px;
  color: ${({ theme }) => theme.blackColor};
  background: ${({ theme }) => theme.whiteColor};
  width: 100%;

  @media (${device.mobile}) {
    padding: 32px 16px 0 16px;
    margin: 0 8px 16px;
  }

  h2 {
    font-weight: bold;
    text-align: center;

    text-transform: uppercase;
    color: ${({ theme }) => theme.blackColor};
    margin-bottom: 32px;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.96px;
  }

  & > span {
    display: inherit;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    margin-bottom: 32px;
    color: ${({ theme }) => theme.mainColor};
    text-overflow: ellipsis;
    max-width: 100%;
    overflow: hidden;
  }

  & > h3 {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    margin-bottom: 32px;
    color: ${({ theme }) => theme.blackColor};

    @media (${device.mobileXS}) {
      margin-bottom: 16px;
      font-size: 28px;
    }
  }

  .avatar {
    width: 96px;
    height: 96px;
    margin: 32px auto 16px;
  }

  .login {
    display: flex;
    justify-content: center;
    & > button {
      margin-top: 16px;
      display: flex;
      align-items: center;
      gap: 4px;

      span {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
      }
      svg {
        transform: rotate(90deg);
        path {
          stroke: ${({ theme }) => theme.secondaryColor};
        }
      }
    }
  }
`;

export const ScLoginWrapButtons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 32px;

  .recovery-btn {
    font-size: 16px;
    line-height: 24px;
    color: #8e8e93;
    margin-top: 16px;

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.blackColor};
      }
    }
  }
`;

export const ScLoginInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 5px;
  text-align: center;

  margin: 32px -32px 0 -32px;
  padding: 12px;
  font-size: 16px;
  line-height: 24px;
  background-color: ${({ theme }) => theme.gray1Color};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  text-transform: none;

  ${ScButtonWrapper} {
    gap: 7px;
  }

  button {
    min-width: auto;
    padding: 0 2px 0 0;
    overflow: visible;

    .text {
      display: flex;
      font-weight: 700;

      font-size: 16px;
      line-height: 24px;
      gap: 7px;
      text-transform: none;
    }

    .awareWrap {
      display: none;
    }
  }
  @media (${device.mobile}) {
    margin: 32px -16px 0 -16px;
  }
`;

export const ScErrorLink = styled.span`
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
`;
